import { io } from "socket.io-client";
import { env } from "../config/env";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

let socket;

export function connectSocket() {
  if (socket?.connected) return socket;

  const token = getAuthToken?.() || "";

  socket = io(env.AUTH_BASE_URL, {
    auth: { token },
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("Socket connected:", socket.id);
  });

  return socket;
}

export function getSocket() {
  return socket;
}